import { GetterTree, ActionTree } from 'vuex';
import { replaceInArray } from '@/utils/Array';
import { messageService } from '@/utils/MessageService';
import { PersistentStore, saveAndSync, syncOperation } from '@/utils/PersistentStore';
import vuestore, { store } from '@/store';
import { CreateTypedStoreProxy } from 'vuex-typed-store';
import { areaBoscoDaSemeService } from '../services/areaBoscoDaSemeService';
import { versioneInSituStore } from '@/modules/VersioneInSitu/store/VersioneInSitu.store';
import { Guid } from 'guid-typescript';
import { syncDeletedRow } from '@/modules/SyncDeletedRow/helper/syncDeletedRowHelper';

export interface AreaBoscoDaSemeStoreModel { }

export interface AreaBoscoDaSemeStoreActions {
  setAreaBoscoDaSeme(payload: server.areaBoscoDaSeme): Promise<void>;
  remove(payload: server.areaBoscoDaSeme): Promise<void>;
  clean(): Promise<void>;
}

export interface AreaBoscoDaSemeStoreGetters {
  get(id): Promise<server.areaBoscoDaSeme>;
  getAll(): Promise<server.areaBoscoDaSeme[]>;
  nearestAreaBoscoDaSeme(): Promise<server.areaBoscoDaSeme>;
}

export const TABLES = { areaBoscoDaSeme: 'AreeBoschiDaSeme' };
export const AreaBoscoDaSemeStore = {
  PREFIX: 'areaBoscoDaSeme',
  namespaced: true,
  mutations: {},
  getters: {
    get: (state) => async (id): Promise<server.areaBoscoDaSeme> => await PersistentStore.get(TABLES.areaBoscoDaSeme, id),
    getAll: (state) => async (): Promise<server.areaBoscoDaSeme[]> => {
      let currentVersion = await versioneInSituStore.getters.current();
      if (!currentVersion) return [];

      var result = await PersistentStore.getAll<server.areaBoscoDaSeme>(TABLES.areaBoscoDaSeme) || [];

      if (result.length > 0) {
        result = await syncDeletedRow(TABLES.areaBoscoDaSeme, result);
      }
      
      var maxts = await PersistentStore.getMaxTs(TABLES.areaBoscoDaSeme);
      areaBoscoDaSemeService.List(currentVersion.id, maxts).then(async (r) => {
        replaceInArray(r, result, (a, b) => a.id == b.id);
        await PersistentStore.set(TABLES.areaBoscoDaSeme, r);
      });
      return result;
    },
    nearestAreaBoscoDaSeme: (state) => async (): Promise<server.areaBoscoDaSeme> => {
      var position = store.getters.ui.currentGPSPosition();
      if (position != null)
        return (await areaBoscoDaSemeStore.getters.getAll()).map(f => { return { distance: distance(f, position), f } })
          .sort((a, b) => a.distance - b.distance).shift()?.f;
      return null;
    }
  } as GetterTree<AreaBoscoDaSemeStoreModel, AreaBoscoDaSemeStoreGetters>,

  actions: {
    async setAreaBoscoDaSeme(context, payload: server.areaBoscoDaSeme) {
      let operation: syncOperation = syncOperation.update;
      if (!payload.id) {
        payload.id = Guid.create().toString();
        operation = syncOperation.create;
      }

      await saveAndSync(payload, TABLES.areaBoscoDaSeme,
        i => operation, i => areaBoscoDaSemeService.Set(i, i.versioneId), i => areaBoscoDaSemeService.Set(i, i.versioneId),
        async (o, n, op) => {
          messageService.publish('updateMediaReference', { type: 'areaBoscoDaSeme', oldTypeId: o.id, newTypeId: n.id } as messages.updateMediaReference);
        })
    },
    async remove(context, payload: server.areaBoscoDaSeme) {
      await areaBoscoDaSemeService.Remove(payload.id, payload.versioneId);
      await PersistentStore.remove(TABLES.areaBoscoDaSeme, payload);
    },
    async clean(context) {
      var result = await PersistentStore.getAll<server.areaBoscoDaSeme>(TABLES.areaBoscoDaSeme) || [];
      if (result.length > 0) {
        return Promise.all(result.map(async (f) => PersistentStore.remove(TABLES.areaBoscoDaSeme, f)));
      }
    }
  } as ActionTree<AreaBoscoDaSemeStoreModel, AreaBoscoDaSemeStoreActions>
}

export const areaBoscoDaSemeStore = CreateTypedStoreProxy<AreaBoscoDaSemeStoreModel, AreaBoscoDaSemeStoreActions, AreaBoscoDaSemeStoreGetters>(vuestore, AreaBoscoDaSemeStore.PREFIX);

function distance(f: server.areaBoscoDaSeme, position: { latitude: number, longitude: number }) {
  return Math.sqrt(
    Math.pow(Math.abs(f.longitude - position.longitude), 2) +
    Math.pow(Math.abs(f.latitude - position.latitude), 2)
  )
}